export default "__VITE_ASSET__CJFEmp_e__"